// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServicePlanPayment-servicePlanPaymentContainer-eX9RV {
    margin-top: 32px;
}

.ServicePlanPayment-container-wk4T_ {
    width: 100%;
    max-width: var(--max-listing-width);
    margin: 0 auto;
    padding-left: 15px;
    padding-right: 15px;
}

.ServicePlanPayment-servicePlanPaymentRow-yp_Vl {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}

.ServicePlanPayment-servicePlanPaymentCol1-bwCPu,
.ServicePlanPayment-servicePlanPaymentCol2-KaNnM {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

.ServicePlanPayment-servicePlanPaymentCol1-bwCPu {
    max-width: 594px;
}

.ServicePlanPayment-servicePlanPaymentCol2-KaNnM {
    max-width: 450px;
}

@media (max-width: 1199px) and (min-width: 992px) {
    .ServicePlanPayment-servicePlanPaymentCol1-bwCPu {
        max-width: 542px;
    }
}

@media (max-width: 991px) {

    .ServicePlanPayment-servicePlanPaymentCol1-bwCPu,
    .ServicePlanPayment-servicePlanPaymentCol2-KaNnM {
        max-width: 100%;
    }

    .ServicePlanPayment-servicePlanPaymentRow-yp_Vl {
        -ms-flex-wrap: wrap-reverse;
            flex-wrap: wrap-reverse;
    }
}

@media (max-width: 991px) and (min-width: 768px) {
    .ServicePlanPayment-servicePlanPaymentRow-yp_Vl {
        gap: 42px;
    }
}

@media (max-width: 767px) {
    .ServicePlanPayment-servicePlanPaymentRow-yp_Vl {
        gap: 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/userServicePlan/ServicePlanPayment/ServicePlanPayment.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAe;QAAf,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;AAClC;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;QACI,2BAAuB;YAAvB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ","sourcesContent":[".servicePlanPaymentContainer {\n    margin-top: 32px;\n}\n\n.container {\n    width: 100%;\n    max-width: var(--max-listing-width);\n    margin: 0 auto;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n\n.servicePlanPaymentRow {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n    justify-content: space-between;\n}\n\n.servicePlanPaymentCol1,\n.servicePlanPaymentCol2 {\n    width: 100%;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n\n.servicePlanPaymentCol1 {\n    max-width: 594px;\n}\n\n.servicePlanPaymentCol2 {\n    max-width: 450px;\n}\n\n@media (max-width: 1199px) and (min-width: 992px) {\n    .servicePlanPaymentCol1 {\n        max-width: 542px;\n    }\n}\n\n@media (max-width: 991px) {\n\n    .servicePlanPaymentCol1,\n    .servicePlanPaymentCol2 {\n        max-width: 100%;\n    }\n\n    .servicePlanPaymentRow {\n        flex-wrap: wrap-reverse;\n    }\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n    .servicePlanPaymentRow {\n        gap: 42px;\n    }\n}\n\n@media (max-width: 767px) {\n    .servicePlanPaymentRow {\n        gap: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"servicePlanPaymentContainer": `ServicePlanPayment-servicePlanPaymentContainer-eX9RV`,
	"container": `ServicePlanPayment-container-wk4T_`,
	"servicePlanPaymentRow": `ServicePlanPayment-servicePlanPaymentRow-yp_Vl`,
	"servicePlanPaymentCol1": `ServicePlanPayment-servicePlanPaymentCol1-bwCPu`,
	"servicePlanPaymentCol2": `ServicePlanPayment-servicePlanPaymentCol2-KaNnM`
};
module.exports = ___CSS_LOADER_EXPORT___;
